import { ZigTheme } from "../types";

const light: ZigTheme = {
  mode: "light",
  fontFamily: ["Avenir Next", "Roboto", "Helvetica", "Arial", "sans-serif"],
  // having this key is important
  // without it overriding would not work
  fontFamilyH1H6: undefined,
  palette: {
    neutral900: "#e0e0e0", // header table and highlighted BG color
    neutral800: "#e8e8e8", // menu main BG color
    neutral750: "#e0e0e0", // secondary menu BG and selected menu item
    neutral700: "#d9d9d9", // division table lines color and hover
    neutral600: "#9c9c9c", // markplace arrow color and some borders
    neutral500: "#dbcbcb", // N/A KILL ME
    neutral400: "#919090", // auxiliar texts color
    neutral300: "#3a3a3a", // highlighted texts color
    /**/ neutral200: "#393939", // menu and table header text color
    neutral175: "#808080", // auxiliar button text color
    neutral150: "#d2d2d2", // arrow color and sub button text color
    neutral100: "#2e2e2e", // header text color
    neutral000: "#222", // button text color
    secondary: "#FFFFFF",
    /**/ highlighted: "#9521f3",
    red: "#EF5350",
    criticalRed: "#D32F2F",
    green: "#26A69A",
    /**/ links: "#9521f3",
    /**/ yellow: "#ab931a",
    contrasting: "#000000",
    lightGrey: "#9ca3af",
    paleBlue: "#8557ff",
    neonGreen: "rgba(0,255,102,0.8)",
    buttonsContrasting: "#c891f4",
    selectOptionSelected: "#8557ff33",
    warningBorder: "#918148",
    warningColor: "#38321c",
    warningBackground: "#fff6cb",
    buttonPrimaryText: "#e0e0e0",
    buttonPrimaryIcon: "#919090",
    qrCodeBackground: "#e0e0e0",
    qrCodeText: "#393939",
    zscoreText: "#e0e0e0",
    investedButtonText: "#e0e0e0",
    investedButtonCoin: "#919090",
    investedButtonEdit: "#e0e0e0",
  },
  backgrounds: {
    zscoreGradientProfits:
      "linear-gradient(to right, #8ae1de, #73e0ff 47%, #0ceaae 88%) /* @noflip */",
    zscoreGradientRisk: "linear-gradient(to right, #a091d4, #5533cf, #50a9ee) /* @noflip */",
    zscoreGradientService:
      "linear-gradient(to right, #c878da, #6d0b82 42%, #aa21c7 76%, #f24196) /* @noflip */",
    zscoreGradientBalanced:
      "linear-gradient(to right, #36995c, #46995c 42%, #76dd88 76%, #88c489) /* @noflip */",
    zscore: "linear-gradient(47deg, #905fff, #b541ff) /* @noflip */",
    inviteTableHighlight: `transparent`,
    zscoreProgressBar: "#ccc",
    tableHeader: "rgba(190, 175, 240, 0.4)",
    marketplaceSelector: "rgba(255,255,255,0.5)",
    marketplaceSelectorWrapper: "rgba(255,255,255,0.5)",
    marketplaceSelectorBorder:
      "linear-gradient(180deg, rgba(180, 150, 255, 0.5) 0%, rgba(180, 150, 255, 0.15) 65%, rgba(180, 150, 255, 0.15) 100%), radial-gradient(circle at 0% 0, rgba(160, 120, 255, 0.6) 0%, transparent 30%), radial-gradient(circle at 100% 50%, rgba(170, 80, 255, 0.5) 0%, transparent 50%) /* @noflip */",
    marketplaceSelectorHover: "rgba(242,240,248,0.5)",
    marketplaceCarousel: `radial-gradient(
      circle at center,
      rgba(213, 199, 251, 0.6) 0%,
      rgba(190, 175, 240, 0.4) 20%,
      rgba(160, 150, 230, 0.2) 30%,
      transparent 90%
    )
    #f2f2f5 /* @noflip */`,
    tableRow: "#f4f4f4",
    body: `#ECEFF1`,
    header: "#f8f8f8",
    toastError: "#f8e6f1",
    toastSuccess: "#bfe8d6",
    neutralBg: "#F5F5F5",
    richTextEditor: `#f5f5f5`,
    buttonPrimary: "linear-gradient(47deg, #703fea, #9521f3) /* @noflip */",
    topServiceCardMarketplaceIcon: "#633fcc",
    commissionBox:
      "linear-gradient(to bottom, rgba(155, 60, 255, 0.4), rgba(79, 135, 255, 0.2)) /* @noflip */",
    howToEarnBorder: "linear-gradient(180deg, #865bb5cc, #9db3d0cc) /* @noflip */",
    howToEarn: "rgba(255, 255, 255, 0.6);",
    tierBarOverlay: (opacity: number) =>
      `linear-gradient(rgba(180, 255, 210, ${opacity}), rgba(200, 255, 230, ${opacity * 0.52})) /* @noflip */`,
    progressLineSignUp: "#ededfa",
    cardBoxInviteModal:
      "radial-gradient(circle at center,rgba(213, 199, 251, 0.6) 0%,rgba(190, 175, 240, 0.4) 20%,rgba(160, 150, 230, 0.2) 30%,transparent 90%) #f2f2f5 /* @noflip */",
    chartImageFill: (isGreen: boolean) => `url(#chart-image-light-${isGreen ? "green" : "red"})`,
  },
  chart: {
    red: "#cc3965",
    green: "#039179",
    greenGradient: ["#03917966", "#039179"],
    greenCardGradient: ["rgba(0,255,109,0.1)", "#03917966", "#039179"],
    greenMiniGradient: ["rgba(0,255,109,0.1)", "#03917966", "#039179"],
    redGradient: ["rgba(255,80,133,0.52)", "rgba(194,42,65,0.69)"],
    redMiniGradient: ["rgba(255,0,0,0.1)", "rgba(255,80,133,0.52)", "rgba(194,42,65,0.69)"],
    redCardGradient: ["rgba(255,0,0,0.1)", "rgba(255,80,133,0.52)", "rgba(194,42,65,0.69)"],
  },
  boxShadows: {
    header: "inset 0 -1px 1px rgba(0, 0, 0, .085)",
    zigMenu: "0 1px 6px -2px #00000031",
  },

  imageColorOverride: "",
};

export default light;
